module.exports = __webpack_public_path__ + "img/contact__img1.c75e53c3.png";